module.exports = __webpack_public_path__ + "img/9.755da9e6.png";